export const PAGINATION = {
  DEFAULT_KEYWORD: '',
  DEFAULT_PAGE: 1,
  DEFAULT_PER_PAGE: 10,
  DEFAULT_TOTAL_PAGE: 10,
  DEFAULT_TOTAL_DATA: 0
};

export const SHOW_ALL_LIMIT = -1;
export const SUCCESS_MESSAGE = 'Success';
export const WEB_LOWERCASE = 'web';
export const ANDROID_LOWERCASE = 'android';
export const ANDROID_CAPITALIZE = 'Android';
export const IOS_LOWERCASE = 'iOS';
export const DEBOUNCE_TIME = 1000;
export const INDEX_FIRST_STRING = 0;
export const INDEX_LAST_STRING_65 = 65;
export const INDEX_LAST_STRING_200 = 200;
export const STATUS_SUCCESS = 200;
export const STATUS_UNAUTHORIZED = 401;
export const STATUS_NULL = null;
export const HOURS_TO_SUBTRACT = 7;
export const TYPE_INPUT_DATE = 'date';
export const TYPE_INPUT_TEXT = 'text';
export const TOKEN_TYPE_SSO = 'Bearer';

export * from './Gamification';
export * from './Cdp';
export * from './responeMessage';
